import { Injectable, inject } from '@angular/core';
import { AuthService } from './auth.service';
import { UserRole } from '../models/user.interface';
import { Permission, PermissionGroupKey, PERMISSION_GROUPS } from '../constants/permissions.constants';

@Injectable({ providedIn: 'root' })
export class PermissionService {
  private readonly authService = inject(AuthService);

  /** Liste brute des permissions de l'utilisateur connecté (single source of truth). */
  get permissions(): readonly string[] {
    return this.authService.permissions();
  }

  hasPermission(permission: Permission | string): boolean {
    return this.authService.permissions().includes(permission);
  }

  hasRole(role: UserRole): boolean {
    return this.authService.userRole() === role;
  }

  hasAnyPermission(permissions: readonly (Permission | string)[]): boolean {
    const userPermissions = this.authService.permissions();
    return permissions.some((p) => userPermissions.includes(p));
  }

  hasAllPermissions(permissions: readonly (Permission | string)[]): boolean {
    const userPermissions = this.authService.permissions();
    return permissions.every((p) => userPermissions.includes(p));
  }

  /** Vérifie une capacité métier regroupant plusieurs permissions (au moins une suffit). */
  hasGroup(group: PermissionGroupKey): boolean {
    return this.hasAnyPermission(PERMISSION_GROUPS[group]);
  }
}
